<div class="row">
    <div class="col-md-12 scroll">
        <rask-list [data]="handelssortimentListaUtvalda">
            <rask-list-column [header]="texts.labelAdd" width="5%">
                <ng-template let-row="row">
                    <rask-button color="tertiary" (click)="addHandelssortimentToMinaHandelssortiment(row.id)" icon="far fa-plus"></rask-button>
                </ng-template></rask-list-column>
            <rask-list-column [header]="texts.labelSearchHandelssortimentsgrupp" field="handelssortimentsgrupp" width="10%" [sortable]="true"></rask-list-column>
            <rask-list-column [header]="texts.labelSearchHandelssortiment" field="namn" width="20%" [sortable]="true"></rask-list-column>
            <rask-list-column [header]="texts.labelProdukt" field="produkter" [sortable]="true"></rask-list-column>
        </rask-list>
    </div>
</div>
